export default __webpack_public_path__ + "static/media/Bluebox-dark.98dfe80c.png";